import { FormattedMessage } from 'react-intl';
// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Init } from '@return-rabbit/nexus';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { noop } from 'ui-components/default-props/noop';

import { useIsShipstationReturnsEnabled } from '../../../../../hooks/use-seller-setting';

import { messages } from './messages';
import style from './style.module.less';

type ChooseItemsStepFooterProps = {
  onCancel?: () => void;
};

export const ChooseItemsStepFooter = ({ onCancel = noop }: ChooseItemsStepFooterProps) => {
  const isSSREnabled = useIsShipstationReturnsEnabled();
  const { onCreate, isProcessing, isDisabled } = Init.useCreateRequest();

  return (
    <FlexRow className={style['button-group']} gap={Gap.Space8}>
      {isSSREnabled ? (
        <Button disabled={isProcessing || !isDisabled} onClick={onCreate} theme='tertiary'>
          <FormattedMessage {...messages.skipItemsStepText} />
        </Button>
      ) : (
        <Button onClick={onCancel} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
      )}
      <Button disabled={isProcessing || isDisabled} onClick={onCreate} theme='primary'>
        <FormattedMessage {...messages.continue} />
      </Button>
    </FlexRow>
  );
};
